import React, { useEffect, useState } from 'react'
import '../../Products/Product.css';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import certificatedata from './certificatedata';
import FooterContact from '../../extracomponents/FooterContact';
import ProductRange from '../../extracomponents/ProductRange';
import ProductHeader from '../../extracomponents/ProductHeader';
import Productcategory from '../../extracomponents/Productcategory';
import Footer from '../../Footer/Footer';
import Header from '../../Header/Header';
import imgbg from "../../images/certificate/(4).jpg"


const Certificate = () => {
    const bgstyle = {

        height: "60vh",
        // margin: "50px",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        background:`linear-gradient(180deg, rgba(0, 0,0, 0.8), rgba(0, 0, 0, .7)), url("${imgbg}")`
        // backgroundImage: `url(${imgbg})`
        // backgroundImage: `url(${imgbg})`


    }
    const [spinner, setspinner] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0)
        setTimeout(() => {
            setspinner(false)
        }, 300);

    }, []);

    const navbraanimate = () => {
        // window.addEventListener("scroll",function(){
        //     const header = document.querySelector('header');
        //     header.classList.toggle('sticky',window.scrollY > 0);
        // });
        const navigation = document.querySelector('nav');

        document.querySelector('.toggle').onclick = function () {
            this.classList.toggle('active');
            navigation.classList.toggle('active');
        }
    }
    return <>
        {
            !spinner && <div>
                {/* Sticky Navbar With Animation Effect */}
                <Header />

                <div className=' d-flex justify-content-center' style={bgstyle}>
                    <div className=" row gx-0 align-items-center  text-white">
                        <div className="col-12 text-center p-5" >
                            <h1>Certificates and Awards</h1>
                            <h5>Through our consistent efforts spanning over the past 20 years, we’ve managed to set a high standard of excellence that has been accredited by prestigious industry authorities. Have a look!</h5>
                        </div>

                    </div>

                </div>


                {/* Gallery==== */}
                {/* <section className="text-center ">

                    <h2>Exhibitions</h2>
                    <div className="row d-flex justify-content-center">
                        <div className="col-8 text-center">

                            <h5>We are very active within the home décor industry. Here is a glimpse into some of the exhibitions and showcase events we’ve been to…</h5>
                        </div>
                    </div>
                </section> */}
                <div class="container py-5">
                    <div class="gallery">
                        {
                            certificatedata.map((item) => (
                                <>
                                    <a href={item.imgsrc}
                                        data-lightbox="models" data-title="Caption1">
                                        <LazyLoadImage
                                            // alt={image.alt}
                                            effect="blur"
                                            src={item.imgsrc}

                                        />

                                    </a>

                                </>
                            ))
                        }




                    </div>
                </div>
                {/* Gallery==== */}

                {/* Cards Animated=== */}

                {/* {Scroll Bar Cards}    */}
                {/* <ProductRange/> */}
                {/* <Productcategory /> */}
                {/* {Scroll Bar Cards}    */}

                {/* Cards Animated=== */}






                {/* Contact=== */}
                <FooterContact />
                {/* Contact=== */}
                <Footer />



            </div>
        }
    </>
};

export default Certificate;
